import { Scene } from "phaser";
import { EventBus } from "../../EventBus.ts";
import { EVENTS_NAME } from "../../consts.ts";

export class MainMenu extends Scene {
  constructor() {
    super("MainMenu");
  }

  update() {}

  create() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    const cx = w / 2;

    // Near-black backdrop
    this.add.graphics().fillStyle(0x05070a, 1).fillRect(0, 0, w, h).setDepth(0);

    // Full-bleed RO car (text-free poster), cover-scaled
    const car = this.add.image(cx, h / 2, "ro_car").setDepth(1);
    car.setScale(Math.max(w / car.width, h / car.height));

    // Dark scrim for legibility — overall dim + heavier top/bottom bands (cinematic)
    const scrim = this.add.graphics().setDepth(2);
    scrim.fillStyle(0x05070a, 0.5).fillRect(0, 0, w, h);
    scrim.fillStyle(0x05070a, 0.85).fillRect(0, 0, w, h * 0.3);
    scrim.fillStyle(0x05070a, 0.6).fillRect(0, h * 0.82, w, h * 0.18);

    // Title — chrome gradient + cyan glow
    const titleSize = Math.min(112, Math.max(40, Math.floor(w * 0.072)));
    const title = this.add
      .text(cx, h * 0.15, "REALI7Y OVERRUN", {
        fontFamily: "Arial Black, Arial, sans-serif",
        fontStyle: "bold",
        fontSize: titleSize,
        color: "#ffffff",
        align: "center",
      })
      .setOrigin(0.5)
      .setDepth(100);
    // Brushed-metal vertical gradient fill (falls back to white if unsupported)
    try {
      const grad = title.context.createLinearGradient(0, 0, 0, title.height);
      grad.addColorStop(0, "#ffffff");
      grad.addColorStop(0.5, "#aab2bb");
      grad.addColorStop(0.55, "#ced5db");
      grad.addColorStop(1, "#6f7882");
      title.setFill(grad);
    } catch (_e) {
      /* keep white fallback */
    }
    title.setShadow(0, 0, "#1fa8e0", 22, true, true);

    // Electric-cyan flare line under the title (with a soft glow band)
    const flareW = title.width * 0.82;
    const flareY = title.y + title.height * 0.6;
    this.add.rectangle(cx, flareY, flareW, 10, 0x1fa8e0).setAlpha(0.18).setDepth(99);
    this.add.rectangle(cx, flareY, flareW, 3, 0x1fa8e0).setAlpha(0.95).setDepth(100);

    // Tagline (WarGames line) — cyan, war-games font
    this.add
      .text(cx, flareY + 40, "Shall we play a game?", {
        fontFamily: "ShallWe, Arial, sans-serif",
        fontSize: Math.min(40, Math.max(18, Math.floor(w * 0.028))),
        color: "#7fd3f2",
        align: "center",
      })
      .setOrigin(0.5)
      .setDepth(100)
      .setShadow(0, 0, "#1fa8e0", 12, false, true);

    // Pulsing "click to continue" prompt
    const prompt = this.add
      .text(cx, h * 0.9, "Click anywhere to continue", {
        fontFamily: "Arial, sans-serif",
        fontSize: Math.min(24, Math.max(14, Math.floor(w * 0.02))),
        color: "#dce3ea",
        align: "center",
      })
      .setOrigin(0.5)
      .setDepth(100);
    this.tweens.add({
      targets: prompt,
      alpha: 0.25,
      duration: 900,
      yoyo: true,
      repeat: -1,
      ease: "Sine.easeInOut",
    });

    // Credits — silver, bottom-center
    this.add
      .text(
        cx,
        h - 14,
        "Game backend by cmdc0de+GHawk · Maps+art+avatars by The Wild Samosa · Game frontend by 0a\nOriginal music by kierkecoder · Additional coding by babu · Sprites/Tilesets by Limezu",
        {
          fontFamily: "Arial, sans-serif",
          fontSize: 11,
          color: "#8a93a0",
          align: "center",
          lineSpacing: 2,
        },
      )
      .setOrigin(0.5, 1)
      .setDepth(100);

    this.input.once("pointerdown", () => {
      this.scene.start("SoundTrackScene");
      this.scene.start("GameMainUIScene");
      this.scene.start("GameMain");
    });
    EventBus.emit(EVENTS_NAME.currentSceneReady, this);
  }
}
